export default __webpack_public_path__ + "static/media/DarkBlue0006.6b3cc9e7.png";